import { TrialInfoResponse } from "src/api/interfaces/user";

import { FAILED_FETCH_TRIAL_DATA, FETCH_TRIAL_DATA, SUCCESS_FETCH_TRIAL_DATA } from "src/services/actions/trial";
import { Action } from "../store";

export type CommonTrialState = {
  errorFetchTrial: [];
  loadingTrial: boolean;
  trial: TrialInfoResponse;
};

const INITIAL_STATE: CommonTrialState = {
  errorFetchTrial: [],
  loadingTrial: false,
  trial: {} as TrialInfoResponse
};

const userReducer = (state = INITIAL_STATE, action: Action): CommonTrialState => {
  if (action.type === FETCH_TRIAL_DATA) {
    return {
      ...state,
      errorFetchTrial: [],
      loadingTrial: true
    };
  }

  if (action.type === SUCCESS_FETCH_TRIAL_DATA) {
    return {
      ...state,
      trial: action.payload,
      loadingTrial: false
    };
  }

  if (action.type === FAILED_FETCH_TRIAL_DATA) {
    return {
      ...state,
      loadingTrial: false,
      errorFetchTrial: action.payload
    };
  }

  return state;
};

export default userReducer;
